import React, { useCallback, useEffect, useState } from 'react';
import { Form, Col } from 'react-bootstrap';
import dayjs from 'dayjs';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCalendarEdit } from '@fortawesome/pro-solid-svg-icons';
import { faTimesCircle } from '@fortawesome/pro-light-svg-icons';


import PopoverTrigger from '../../components/PopoverTrigger';
import ReportDatePicker from './ReportDatePicker';
import CHARTCOLORS from '../../helpers/chartColors';

const styles = {
  label: {
    display: 'flex',
  },
  inputStyle: {
    textAlign: 'center',
    marginRight: '10px',
  },
  buttonStyle: {
    fontSize: '22px',
    color: CHARTCOLORS[1],
  },
  buttonContainerStyle: {
    cursor: 'pointer',
    pointerEvents: 'auto',
    position: 'absolute',
    top: '57%',
    right: '20px',
  },
  cancelStyle: {
    position: 'absolute',
    right: '45px',
    top: '38px',
    fontSize: '18px',
    lineHeight: 'inherit',
    color: 'red',
    cursor: 'pointer',
  },
};

function ReportMonthRange(props) {
  const {
    major_label,
    label,
    default_date,
    min_date,
    max_date,
    payload_key,
    updatePayload,
    updateLocal,
    showPicker,
    clearOption,
  } = props;

  const [currentDate, setCurrentDate] = useState('');
  const [dateString, setDateString] = useState('');

  const setDate = useCallback(
    (date) => {
      if (date) {
        const new_date = dayjs.utc(date);
        setCurrentDate(new_date);
        updatePayload(payload_key + '_year', new_date.year());
        updatePayload(payload_key + '_month', new_date.month() + 1);
        updateLocal(payload_key + '_year', new_date.year());
        updateLocal(payload_key + '_month', new_date.month() + 1);
      }
      else {
        setCurrentDate('')
        updatePayload(payload_key + '_year', 'none');
        updatePayload(payload_key + '_month', 'none');
        updateLocal(payload_key + '_year', 'none');
        updateLocal(payload_key + '_month', 'none');
      }
    },
    [payload_key, updatePayload, updateLocal]
  );

  useEffect(() => {
    if (default_date) {
      setDate(default_date);
    }
  }, [setDate, default_date]);

  useEffect(() => {
    if (currentDate) {
      let str = '';
      const local_date = dayjs(currentDate);
      if (payload_key.includes('start')) {
        str =
          local_date.format('MMMM YYYY') +
          ' - ' +
          local_date.month(local_date.month() + 11).format('MMMM YYYY');
      } else if (payload_key.includes('end')) {
        str =
          local_date.month(local_date.month() - 11).format('MMMM YYYY') +
          ' - ' +
          local_date.format('MMMM YYYY');
      }

      setDateString(str);
    }
    else {
      setDateString('None');
    }
  }, [currentDate, payload_key]);

  return (
    <Form.Group as={Col}>
      <Form.Label style={styles.label}>{major_label}</Form.Label>
      <Form.Control
        style={styles.inputStyle}
        size='sm'
        disabled
        value={dateString}
      />
      {clearOption && currentDate &&
        <div id='report-clear-option'>
          <FontAwesomeIcon
            style={styles.cancelStyle}
            icon={faTimesCircle}
            onClick={() => setDate(null)}
          />
        </div>}
      <div
        id='report-popover-button'
        style={styles.buttonContainerStyle}
        hidden={!showPicker}
      >
        <PopoverTrigger
          rootClose={true}
          popoverTitle={label}
          popoverContent={
            <ReportDatePicker
              currentDate={currentDate}
              setDate={setDate}
              minDate={min_date}
              maxDate={max_date}
            />
          }
          trigger='click'
          placement='bottom'
        >
          <FontAwesomeIcon
            style={styles.buttonStyle}
            icon={faCalendarEdit}
            id={'report-date-popover'}
          />
        </PopoverTrigger>
      </div>
    </Form.Group>
  );
}

ReportMonthRange.defaultProps = {
  updateLocal: (x, y) => { },
  showPicker: true,
  clearOption: false,
};

export default ReportMonthRange;
